<template>
  <div class="intes-bt">
    <img
      :src="require(`@/assets/image/anxin/nyhead.png`)"
      class="intes-bt-bg"
    />
    <div class="intes-bt-img">
      <img :src="require(`@/assets/image/anxin/nyjf.png`)" />
    </div>
    <div class="intes-bt-test">
      <div
        :style="{
          color:
            marks <= 60
              ? '#D45353'
              : marks >= 61 && marks <= 74
              ? '#f1be33'
              : marks >= 75 && marks <= 84
              ? '#9ef133'
              : '#28d200',
        }"
      >
        <b
          ><NumberGrow
            :value="marks"
            :fontSize="'0.96rem'"
            :fontWeight="'bold'"
          ></NumberGrow></b
        >分
      </div>
      <p>{{ name }}总分</p>
    </div>
    <div class="intes-bt-fs" @click="handClickFs">分数说明</div>
  </div>
</template>
<script>
import NumberGrow from "./NumberGrow.vue"
export default {
  props: ['marks', 'name'],
  components: {
    NumberGrow
  },
  data () {
    return {


    }
  },
  watch: {

  },
  methods: {
    handClickFs () {
      this.$emit('handClickFs');
    }
  }
}
</script>
<style lang="scss" scoped>
.intes-bt {
  height: 250px;
  position: relative;
  .intes-bt-bg {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    height: 271px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .intes-bt-img {
    position: absolute;
    z-index: 2;
    width: 226px;
    height: 245px;
    left: 50%;
    top: 10px;
    margin-left: -113px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .intes-bt-test {
    position: absolute;
    width: 246px;
    height: 245px;
    left: 50%;
    z-index: 2;
    top: 10px;
    margin-left: -120px;
    padding-top: 60px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    b {
      font-size: 72px;
      font-weight: bold;
    }
    p {
      font-size: 20px;
      margin: 0;
      color: #999;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: -5px;
    }
  }
  .intes-bt-fs {
    position: absolute;
    z-index: 2;
    right: 27px;
    top: 10px;
    text-decoration: underline;
    font-size: 26px;
    color: #fff;
  }
}
</style>